import { http } from '@/lib/http';

/**
 * Mirrors `repo.Tier` in the vizitpro-api swagger spec — the static lookup
 * of subscription tiers VizitPro offers.
 */
export interface TierDto {
  id: string;
  slug: string;
  label: string;
  monthly_price_cents: number;
  annual_price_cents: number;
  is_active: boolean;
  created_at: string;
  /**
   * Stripe Price IDs for this tier's monthly/annual billing cycles. Not sent
   * anywhere by the frontend directly — `createCheckoutSession` takes
   * `tier_id` + `billing_cycle` and the backend resolves the price. Present
   * mainly so `monthly_price_cents`/`annual_price_cents` can be trusted as
   * what Stripe will actually charge.
   */
  stripe_price_id_monthly: string;
  stripe_price_id_annual: string;
}

/**
 * React Query cache key for the tiers lookup. Static reference data — safe
 * to cache for the lifetime of the app session.
 */
export const TIERS_QUERY_KEY = ['tiers'] as const;

/** Calls `GET /tiers`. */
export async function listTiers(): Promise<TierDto[]> {
  const { data } = await http.get<TierDto[]>('/tiers');
  return data;
}
